var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "visible",
    preserveAspectRatio: "none",
    viewBox: "0 0 20 20",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0) rotate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,0c-5.51,0 -10,4.49 -10,10c0,5.51 4.49,10 10,10c5.51,0 10,-4.49 10,-10c0,-5.51 -4.49,-10 -10,-10zM9,8v-3c0,-0.55 0.45,-1 1,-1v0c0.55,0 1,0.45 1,1v3h1.79c0.45,0 0.67,0.54 0.35,0.85l-2.79,2.79c-0.2,0.2 -0.51,0.2 -0.71,0l-2.79,-2.79c-0.31,-0.31 -0.09,-0.85 0.36,-0.85zM14,15h-8c-0.55,0 -1,-0.45 -1,-1v0c0,-0.55 0.45,-1 1,-1h8c0.55,0 1,0.45 1,1v0c0,0.55 -0.45,1 -1,1z",
    style: {
      strokeWidth: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      fill: "rgb(0, 74, 93)"
    },
    vectorEffect: "non-scaling-stroke"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "path-1630670489180156958",
    d: "M10,0c-5.51,0 -10,4.49 -10,10c0,5.51 4.49,10 10,10c5.51,0 10,-4.49 10,-10c0,-5.51 -4.49,-10 -10,-10zM9,8v-3c0,-0.55 0.45,-1 1,-1v0c0.55,0 1,0.45 1,1v3h1.79c0.45,0 0.67,0.54 0.35,0.85l-2.79,2.79c-0.2,0.2 -0.51,0.2 -0.71,0l-2.79,-2.79c-0.31,-0.31 -0.09,-0.85 0.36,-0.85zM14,15h-8c-0.55,0 -1,-0.45 -1,-1v0c0,-0.55 0.45,-1 1,-1h8c0.55,0 1,0.45 1,1v0c0,0.55 -0.45,1 -1,1z",
    vectorEffect: "non-scaling-stroke"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/Download.76d6e067fc54421389c9587a5feccb35.svg";
export { ForwardRef as ReactComponent };